module.exports = __webpack_public_path__ + "bottomLogo.0e3aaef3.png";